<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <template>
            <v-card class="box">
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Notice Report
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
             
                <v-row justify="center">
                <v-col cols="12" sm="2">
                    <!-- <p><v-icon color="error">*</v-icon><b>From Date</b></p> -->
                    <v-text-field outlined dense type="date" v-model="fromdate" label="From Date"
                        hint="From Date"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                    <!-- <p><v-icon color="error">*</v-icon><b>To Date</b></p> -->
                    <v-text-field outlined dense type="date" v-model="todate" label="To Date"
                        hint="To Date"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                    <!-- <p><br></p> -->
                    <v-btn @click="fetchNotices()" :loading="send_btn_load" color="info">Fetch Notices</v-btn>
                </v-col>
            </v-row>
              
            </v-card>

           

            <v-row dense justify="center" v-if="communication_list != ''">
                <v-radio-group inline v-model="view" row>
                    <v-radio label="Single" value="Single"></v-radio>
                    <v-radio label="Cummalative" value="Cummalative"></v-radio>
                </v-radio-group>
            </v-row>
            <br />
            <!-- <center> -->

            <!-- </center> -->
            <template v-if="view == 'Single'">
                <div>
                    <div v-if="communication_list.length != 0">
                        <v-data-table :items="bookList1" :headers="headers" class="elevation-1 mytable" :search="search"
                            @current-items="getFiltered">
                            <template v-slot:top>
                                <v-toolbar flat class="toolbar" color="white" align="center" justify="center">
                                    <v-toolbar-title><b>List of Notices</b> <small>[ AY:{{ d_ay }} || {{ from_date }} to
                                            {{ to_date }} ] </small></v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <!-- <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field> -->
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field v-model="search" append-icon="search" label="Search" rounded
                                            background-color="white" color="white" hide-details></v-text-field>
                                    </v-col>
                                </v-toolbar>
                                <v-row dense>
                                    <tr class="t-row">
                                        <div>
                                            <th>
                                                <v-row>
                                                    <span v-for="header in headers" :key="header.text">
                                                        <span v-if="filters.hasOwnProperty(header.value)">
                                                            <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details
                                                                small rounded dense outlined color="#0F2027"
                                                                :label="header.text" multiple clearable
                                                                :items="columnValueList(header.value)"
                                                                v-model="filters[header.value]"></v-autocomplete>
                                                        </span>
                                                    </span>
                                                </v-row>
                                            </th>
                                        </div>
                                    </tr>
                                </v-row>
                            </template>
                            <template v-slot:[`item.description`]="{ item }">
                                <v-btn color="success" icon dark @click="getDescription(item.description)"
                                    title="Get status">
                                    <v-icon> mdi-book-open</v-icon>
                                </v-btn>
                                <!-- {{ item.description }} -->
                            </template>

                            <template v-slot:[`item.url`]="{ item }">
                                <a :href="item.url" target="_blank" v-if="item.url != '--'">
                                    <v-icon class="mr-2 v-icon-size" color="primary">mdi-login</v-icon>
                                </a>
                                <span v-else style="opacity: 0.5;">{{ item.url }}</span>
                            </template>
                            <template v-slot:[`item.attachment`]="{ item }">
                                <span v-if="item.attachment_list.length > 0">
                                    <span v-for="(item, i) in item.attachment_list" :key="i">
                                        <a class="p-2" :href="basepath + item.link" target="blank">
                                            <v-tooltip top>
                                                <template v-slot:activator="{ attrs }">
                                                    <v-btn icon v-if="item.link != null" v-bind="attrs"> <v-icon
                                                            color="black">mdi-eye</v-icon></v-btn>
                                                </template>
                                                <span> View Attachment File!!! </span>
                                            </v-tooltip>
                                        </a>
                                    </span>
                                </span>
                                <!-- </span>    -->
                            </template>
                        
                           
                        </v-data-table>
                    </div>
                </div>
            </template>
            <template v-if="view == 'Cummalative'">
                
                <v-toolbar flat class="toolbar" color="white" align="center" justify="center">
                    <v-col cols="12" sm="3" md="12">
                        <v-text-field v-model="searchQuery" append-icon="search" label="Search" rounded
                            background-color="white" color="white" hide-details></v-text-field>
                    </v-col>
                </v-toolbar>
                <v-row dense>
                    <!-- {{ cum_list }} -->

                    <v-col cols="12" sm="12" md="12" v-for="(value, key) in cum_list" :key="key"
                        v-if="matchesSearch(value, searchQuery)">
                        <v-card class="box box1" fill-height>
                           <span v-for="(std, ind) in value" :key="ind">
                                <h3 v-if="ind == 0">Title : {{ value[0] }}</h3>
                                <div v-else-if="ind == 1">
                                    <b> Description:</b>{{ value[1] }} <br />
                                    <span> {{ std }} </span><br />
                                </div>
                                <v-btn color="info" small style="margin: 2px;" v-else>
                                    {{ std }}
                                </v-btn>
                            </span>
                        </v-card>
                    </v-col>
                </v-row>
            </template>
            <v-dialog v-model="description_dialog" max-width="1200px">
                <v-card>
                    <v-card-text>
                        {{ show_description }}
                    </v-card-text>
                    <v-card-actions class="justify-center"><v-btn color="warning"
                            @click="description_dialog = false">Close</v-btn></v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="status_dialog" max-width="1200px">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="status_headers" :items="comm_read_status" :search="search"
                            @current-items="getFiltered" :items-per-page="-1">
                            <template v-slot:top>
                                <v-toolbar flat color="white" align="center" justify="center">
                                    <v-toolbar-title>List of Receipients</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <strong>Total Receipients- </strong>{{ total_receipients }}
                                    <v-spacer></v-spacer>
                                    <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                        hide-details></v-text-field>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions class="justify-center"><v-btn class="dialog-btn"
                            @click="status_dialog = false">Close</v-btn></v-card-actions>
                </v-card>
            </v-dialog>

           
        </template>
        <div class="text-center">
            <v-dialog v-model="init_loader" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please Wait
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data: () => ({
        isvalid: true, Message: null,
        file_upload_config: { allowed_type: "", max_size: 1000 },
        rules: [(value) => !value || value.size < 2000000 || "Logo size should be less than 2 MB!"],
        textRule: [(v) => !!v || "Field is required"],

        attachments: [],
        ay_list: [],
        academicyear: "",
        stream: "",
        stream_list: [],
        standard_list_all: [],
        standard: [],
        event_type_list: [],
        division_list: [],
        standard_list: [],
        division: [],
        event_type: "",
        datetime: null,
        search: "",
        searchQuery: "",
        snackbar_msg: "",
        snackbar: false,
        color: "",
        communication_list: [],
        get_communication_list_for_resend: [],
        awspath: null,

        send_btn_load: false,
        delete_attach_load: false,
        basepath: "",
        description: "",
        link: "",
        edit_save_attachment_load: false,
        edit_attachments: [],
        filterArr: [],
        delete_acttach_load: false,
        filters: {
            // std: [],
            title: [],
            date: [],
            to: [],
        },
        status_headers: [
            { text: "Sr No", value: "srno", sortable: true },
            { text: "Read By", value: "learner", sortable: true },
            { text: "Read Date", value: "read_date", sortable: true },
        ],
        headers: [
            { text: "Academicyear", value: "academicyear", sortable: true },
            { text: "Sent Date", value: "date", sortable: true },
            { text: "From", value: "from", sortable: true },
            { text: "To", value: "to", sortable: true },
            { text: "Title", value: "title", sortable: true },
            { text: "Description", value: "description", sortable: true },
            { text: "Attachments", value: "attachment", sortable: true },
            { text: "Link", value: "url", sortable: true },
          
        ],
       
        //editItemIndex: -1,
        title: null,
        web_Link: "",
        edit_dialog: false,
        edit_when_resend_dialog: false,
        edit_when_resend_loader: false,
        edit_when_resend_comulative_dialog: false,
        edit_when_resend_comulative_loader: false,
        comm_read_status: [],
        status_dialog: false,
        description_dialog: false,
        show_description: "",
        total_receipients: "",
        //
        d_ay: null,
        // from_date: null,
        // to_date: null,
        init_loader: false,
        delete_loader: false,
        //
        view: "",
        cum_list: null,
        // fromdate: new Date().toISOString().slice(0, 10),
        fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        todate: new Date().toISOString().slice(0, 10),
    }),
    watch: {},
    methods: {
        getdataresendCumulative(item) {

            const formData = {
                key: item

            };
            axios
                .post("/Communication/getdataresendNoticeHWAlbumCumulative", formData)
                .then((res) => {
                    if (res.data.flag == "Yes") {

                        this.get_communication_list_for_resend = res.data.communication_list[0];
                        this.editedItem_for_comulative_resend = {


                            title: this.get_communication_list_for_resend.title,
                            url: this.get_communication_list_for_resend.url,
                            from: this.get_communication_list_for_resend.from, // Add from field if needed
                            to: this.get_communication_list_for_resend.to, // Add from field if needed

                            description: this.get_communication_list_for_resend.description,
                            attachment_list: this.get_communication_list_for_resend.attachment_list,
                            date: this.get_communication_list_for_resend.date, // Add date if needed
                            key: this.get_communication_list_for_resend.key

                        };

                        // Open the dialog after populating data
                        this.edit_when_resend_comulative_dialog = true;

                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.init_loader = false;
                });
        },

        resendCumulative() {
            if (!confirm("Are You Sure You Want To Edit And Resend This Communication?")) return;
            this.init_loader = true
            this.edit_when_resend_comulative_loader = true
            let formData = new FormData();
            for (var i = 0; i < this.edit_attachments.length; i++) {
                let file = this.edit_attachments[i];

                formData.append("files", file);
            }
            formData.append("title", this.editedItem_for_comulative_resend.title);
            formData.append("link", this.editedItem_for_comulative_resend.url);
            formData.append("description", this.editedItem_for_comulative_resend.description);
            formData.append("key", this.editedItem_for_comulative_resend.key);
            axios
                .post("/Communication/resendNoticeHWAlbumCumulative", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Notice/HW Added Successfully..."); // show snackbar on success
                        this.edit_when_resend_comulative_dialog = false;
                        this.edit_when_resend_comulative_loader = false;

                    }
                    if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.edit_when_resend_comulative_dialog = false;
                        this.edit_when_resend_comulative_loader = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                    this.edit_when_resend_comulative_dialog = false;
                    this.edit_when_resend_comulative_loader = false;
                })
                .finally(() => {
                    this.init_loader = false
                    this.get_ay_std();
                    this.fetchNotices();
                    this.edit_when_resend_comulative_dialog = false;
                    this.edit_when_resend_comulative_loader = false;
                });
        },
      
        matchesSearch(value, query) {
            // Implement your custom filtering logic here
            const searchString = query.toLowerCase();

            // For example, you can check if the title or description contains the search query:
            const title = value[0].toLowerCase();
            const description = value[1].toLowerCase();

            return title.includes(searchString) || description.includes(searchString);
        },
        fetchNotices() {
            this.init_loader = true;
            const formData = {
                comm_type: "Notice",
                for: "all",
                fromdate: this.fromdate,
                todate: this.todate,
                ay: this.academicyear.id,
            };
            axios
                .post("/Communication/getNoticesBetweenDates", formData)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.d_ay = res.data.d_ay;
                        this.from_date = res.data.from_date;
                        this.to_date = res.data.to_date;
                        this.communication_list = res.data.communication_list;
                        this.cum_list = res.data.cum_list;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.init_loader = false;
                });
        },
       
        getDescription(description) {
            this.show_description = description;
            this.description_dialog = true;
        },
       
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.communication_list.map((d) => d[val]);
        },
        clearData() {
            (this.division = []), (this.stream = ""), (this.title = ""), (this.link = ""), (this.description = ""), (this.attachments = []);
            this.standard = [];
            this.academicyear = null;
        },
        getStatus(id) {
            const formData = {
                comm_id: id,
            };
            axios
                .post("/Communication/getcommunicationStatus", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.comm_read_status = res.data.read_list;
                        this.status_dialog = true;
                        this.total_receipients = res.data.total_receipients;
                    }
                    if (res.data.flag == "No") {
                        this.showSnackbar("#b71c1c", res.data.snackbar);
                        this.status_dialog = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => { });
        },
       
      
        get_divisions_stream(stream, type) {
            if (type == "stream") {
                const formData = {
                    ay: this.academicyear.id,
                    stream: stream.id,
                };
                this.division = [];
                axios
                    .post("/Communication/get_stream_divisions", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.division_list = res.data.division_list;
                            // this.standard_list=res.data.standard_list;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.standard = [];
                    });
            }
            if (type == "standard") {
                const formData = {
                    ay: this.academicyear.id,
                    standard: stream,
                };
                this.division = [];
                axios
                    .post("/Communication/get_standard_divisions", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.division_list = res.data.division_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    })
                    .finally(() => {
                        this.stream = "";
                    });
            }
        },

        hasWhiteSpace(s) {
            var status = false;
            var reWhiteSpace = new RegExp(/^\s+$/);

            // Check for white space
            if (reWhiteSpace.test(s)) {
                // alert("Please Check Your Fields For Spaces");
                return true;
            }
            return false;
        },

        putCalendar() {
            //alert(this.academicyear.id)
            // alert(this.standard,length)
            if (this.hasWhiteSpace(this.title) || this.title == null) {
                this.showSnackbar("#b71c1c", "Please Enter Title");
                return;
            }

            this.send_btn_load = true;
            let formData = new FormData();
            for (var i = 0; i < this.attachments.length; i++) {
                let file = this.attachments[i];
                formData.append("files", file);
            }
            for (var i = 0; i < this.division.length; i++) {
                let division = this.division[i].id;
                formData.append("div", division);
            }
            for (var i = 0; i < this.standard.length; i++) {
                let standard = this.standard[i];
                formData.append("standard", standard);
            }
            formData.append("ay", this.academicyear.id);
            formData.append("stream", this.stream.id);
            // formData.append("standard", this.standard);
            formData.append("title", this.title);
            formData.append("link", this.link);
            formData.append("description", this.description);
            formData.append("type", "Notice");
            axios
                .post("/Communication/putNoticeHWAlbum", formData, {})
                .then((res) => {
                    if (res.data.msg == "200") {
                        if (res.data.status == "SUCCESS") {
                            // alert("Success");
                            this.showSnackbar("#4caf50", "Notice/HW Added Successfully..."); // show snackbar on success
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                            //alert(res.data.status_reason);
                        }
                        //this.get_calendar();
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.send_btn_load = false;
                    this.get_ay_std();
                    this.clearData();
                    this.fetchNotices();
                });
        },
        get_ay_std() {
            this.init_loader = true;
            const formData = {
                comm_type: "Notice",
                for: "all",
            };
            axios
                .post("/Communication/gerInitialData", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.d_ay = res.data.d_ay;
                        //this.from_date = res.data.from_date;
                        //this.to_date = res.data.to_date;
                        //this.communication_list = res.data.communication_list;
                        //this.cum_list = res.data.cum_list;
                        (this.ay_list = res.data.ay_list), (this.academicyear = res.data.current_ay);
                        // this.stream_list=res.data.stream_list
                        this.stream_list = res.data.stream_list_all;
                        this.standard_list_all = res.data.standard_list_all;
                        this.isvalid = res.data.isvalid,
                            this.Message = res.data.Message
                    } else if (res.data.flag == "No") {
                        this.d_ay = res.data.d_ay;
                        (this.ay_list = res.data.ay_list),
                            (this.academicyear = res.data.current_ay);
                        this.stream_list = res.data.stream_list_all;
                        this.standard_list_all = res.data.standard_list_all;
                        this.isvalid = res.data.isvalid,
                            this.Message = res.data.Message
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.init_loader = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
       
    },
    mounted() {
        this.init_loader = true;
        this.get_ay_std();
        this.basepath = localStorage.getItem("awspath");
        this.view = "Single";
    },
    computed: {
        bookList1() {
            if (this.communication_list.length == 0) return;
            return this.communication_list.filter((d) => {
                return Object.keys(this.filters).every((f) => {
                    return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                });
            });
        },

        // filteredData() {
        //           return this.cum_list.filter((item) => {
        //               const searchTerm = this.search.toLowerCase();
        //               if (item.title.toLowerCase().includes(searchTerm)) {
        //                   return item.title.toLowerCase().includes(searchTerm);}
        //                   else if(item.description.toLowerCase().includes(searchTerm)){
        //                       return item.description.toLowerCase().includes(searchTerm);
        //                   }

        //           });
        // },
    },
};
</script>
<style scoped>
.allot-btn,
.allot-icon,
.info-icon {
    transition: 0.3s;
}

.allot-btn:hover .allot-icon {
    color: white;
}

.allot-btn:hover {
    background-color: #193a9a !important;
    border-color: #193a9a !important;
    color: white;
}

.info-icon:hover {
    background-color: #193a9a !important;
    border-color: #193a9a !important;
    color: white;
    border-radius: 100%;
}

.table-sub-title {
    margin-left: 1%;
    font-weight: 500;
    color: #999;
}

@media print {
    body {
        height: 100%;
        width: 100%;
    }

    .no-display {
        display: none !important;
    }

    .v-data-footer,
    .v-data-footer__select,
    .v-data-footer__pagination {
        display: none !important;
        visibility: hidden !important;
    }

    .v-data-table table,
    .v-data-table__wrapper {
        width: 100% !important;
        display: block !important;
    }

    table,
    th,
    td {
        border-collapse: collapse !important;
        border: 1px solid black !important;
        width: 100%;
        text-align: right !important;
    }
}

.box1 {
    height: 100%;
}
</style>
